import "core-js/modules/es.array.concat.js";
import React from 'react';
import { getFundMainClass } from '@finect/front-resources/Products';
import { AssetsLabel } from '../../../Labels';
export var FundClassMinInvestment = function FundClassMinInvestment(_ref) {
  var fundClass = _ref.fundClass,
    _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === void 0 ? 0 : _ref$decimals;
  if (!fundClass) {
    return '—';
  }
  var currency = fundClass.currency;
  var _fundClass$minimalInv = fundClass.minimalInvestment,
    amount = _fundClass$minimalInv.amount,
    participation = _fundClass$minimalInv.participation;
  if (amount !== null) {
    return React.createElement(AssetsLabel, {
      value: amount,
      decimals: decimals
    });
  }
  if (participation !== null) {
    return "".concat(participation, " ").concat(participation === 1 ? 'participación' : 'participaciones');
  }
  return React.createElement(AssetsLabel, {
    value: null,
    scale: "one",
    currency: currency.code,
    decimals: 0
  });
};
export var FundMinInvestment = function FundMinInvestment(_ref2) {
  var entity = _ref2.entity,
    _ref2$decimals = _ref2.decimals,
    decimals = _ref2$decimals === void 0 ? 0 : _ref2$decimals,
    params = _ref2.params;
  if (params.model === 'content') {
    return entity.minInvestment;
  }
  var fundClass = getFundMainClass(entity);
  return React.createElement(FundClassMinInvestment, {
    fundClass: fundClass,
    decimals: decimals
  });
};